<template>
    <el-dialog :title="$t('train.qrCode')"
               :visible="value"
               :modal-append-to-body="false"
               width="750px"
               height="600px"
               @close="close"
    >
        <div id="erweima_generate" class="qrcode-wrap">
            <p class="current-org">{{$t('train.currentOrg')}} :<span id="org_name" class="org_name">{{selectedOrgName}}</span></p>
            <div class="box" style="margin-bottom: 20px;">
                <div class="left-box">
                    <el-row class="title">
                        <el-col :span="2">
                            <i class="nucfont inuc-organization"></i>
                        </el-col>
                        <el-col :span="20">
                            {{$t('c.organizations')}}
                        </el-col>
                    </el-row>
                    <div class="tree-container" id="treeContainer">
                        <select-SingleOrg
                            :isTreePop="false"
                            :default-expand-all="false"
                            v-on:getTreeNodeData="getNodeVal">
                        </select-SingleOrg>
                    </div>
                </div>
                <div class="QRCode_wrapper">
                    <div class="btn_generate">
                        <p class="due-title">{{$t('train.dueTime')}}:</p>
                        <el-date-picker
                            type="datetime"
                            :placeholder="$t('tip.datetime')"
                            v-model="expiry"
                            format="yyyy-MM-dd HH:mm"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd HH:mm"
                            default-time="23:59:59"
                            @change="dueTimeChange"
                        ></el-date-picker>
                        <p class="qr-make" :title="$t('train.qrCode')" @click="qrCodeCreate"><i class="nucfont inuc-click"></i></p>
                    </div>
                    <div class="QRCode_box">
                        <p id="tipinfo" class="tipinfo" v-if="!isQRCode">{{$t('train.clickOrgFirst')}}</p>
                        <!--<img id="logo" src="../../assets/images/mobile_login.png" v-if="isQRCode"-->
                        <!--class="centerimg display_none">-->
                        <img :src="qrValue" v-if="isQRCode">
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import config from "@/config";

export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        data: {
            required: true
        },
    },

    data() {
        return {
            planID: undefined,
            isQRCode: false,
            qrValue: '',
            size: 180,
            selectedOrgName: '',
            orgID: '',
            qrCodeDialog: false,
            count: 0,
            expiry:'',
        }
    },

    computed: {
        pickerOptions() {
            return {
                disabledDate(time) {
                    if (new Date(time).toDateString() === new Date().toDateString()) return false;
                    return time.getTime() < new Date().getTime()
                },
            }
        },
    },

    watch: {
        value(val) {
            // 打开
            if (val) {
                this.initDialog();
            }
        },
    },

    methods: {
        initDialog() {
            this.planID = this.data.id

            this.selectedOrgName = ''
            this.isQRCode = false;
            this.orgID = '';
            this.expiry='';
        },

        getNodeVal(data) {
            let that = this;
            this.selectedOrgName = data.name;
            this.orgID = data.id;
            this.isQRCode = false;

            //所属机构的联动
            $(".tree-container-pop .el-tree-node__label").each(function () {
                $(this).parent(".el-tree-node__content").removeClass("pink");
                if ($(this).text() == that.orgForm.superiorName) {
                    $(this).parent(".el-tree-node__content").addClass("pink");
                }
            })
        },
        qrCodeCreate() {
            if(!this.orgID){
                this.$message(this.$t('tip.chooseOrgFirst'));
                return;
            }
            if(!this.expiry){
                this.$message(this.$t('tip.chooseDueDate'));
                return;
            }
            if (this.expiry && new Date(this.expiry).getTime() < new Date().getTime()) {
                this.$message(this.$t('rule.time'));
                return;
            }
            this.qrValue = this.getEnterpriseCode(this.orgID, this.planID,this.expiry)
            this.isQRCode = true;
        },
        getEnterpriseCode(orgID, planID,expiry) {
            let userInfo = this.$store.getters.userInfo
            let enterpriseCode = userInfo.enterpriseCode;
            const culture = this.$i18n.locale;

            return `${config.baseUrl}/qrapi/image/training/${planID}/invitation?orgId=${orgID}&enterpriseCode=${enterpriseCode}&expiry=${expiry}&culture=${culture}&ui-culture=${culture}`;
        },
        dueTimeChange(){
            this.isQRCode = false
            if (this.expiry && new Date(this.expiry).getTime() < new Date().getTime()) {
                this.$message(this.$t('rule.time'));
                return;
            }
        },

        close() {
            this.$emit('input', false)
        }
    },
}
</script>

<style scoped lang="scss">
.qrcode-wrap {
    margin: 15px 15px 20px 15px;
    .current-org {
        margin-bottom: 15px;
        .org_name {
            color: #2e7faa;
            padding-left: 10px;
        }
    }
    .box {
        display: flex;
        position: relative;

        .left-box {
            width: 280px;
            @include scrollbar();
            border: 1px solid rgb(221, 221, 221);
            .title {
                background-color: #f4f3f8;
                border-bottom: 1px solid rgb(221, 221, 221);
                padding: 5px 10px;
                .inuc-organization {
                    color: #2e7faa;
                    line-height: 22px;
                }
            }
            .tree-container {
                overflow-y: auto;
                max-height: 460px;
                background-color: #fff;
                padding: 12px;
            }

        }
        .QRCode_wrapper {
            margin-left: 20px;
            /*padding-top: 40px;*/
            .btn_generate {
                /*text-align: center;*/
                cursor: pointer;
                margin-bottom: 30px;
                display: flex;
                .due-title{
                    line-height: 40px;
                    margin-right: 5px;
                }
                .qr-make {
                    padding: 10px 25px 10px 20px;
                    //background: linear-gradient(#70a2ff, #23c4d9);
                    background-color:#22B9FF;
                    color: #fff;
                    border-radius: 4px;
                    position: relative;
                    margin-left: 15px;
                    i {
                        font-size: 28px;
                        position: absolute;
                        right: 8px;
                        top: 5px;
                        animation: clickmove 1s infinite;
                        -webkit-animation: clickmove 1s infinite alternate;
                    }
                }
            }
            .QRCode_box {
                width: 180px;
                height: 180px;
                //border: 2px solid #0a8ddf;
                border-radius: 4px;
                margin: 0 auto;
                position: relative;
                background: radial-gradient(#84d6fe, #269bea);
                .centerimg {
                    border: 1px solid #fff;
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    margin-left: -16px;
                    margin-top: -16px;
                    left: 50%;
                    top: 50%;
                    z-index: 100;
                }
                .tipinfo {
                    width: 120px;
                    height: 40px;
                    position: absolute;
                    margin-top: -16px;
                    top: 45%;
                    left: 50%;
                    margin-left: -60px;
                    text-align: center;
                    z-index: 100;
                    color: #fff;
                }
            }
        }

    }
}

@keyframes clickmove {
    0% {
        transform: scale(0.7, 0.7);
    }
    100% {
        transform: scale(1.3, 1.3);
    }
}
</style>
